import { gql } from 'graphql-tag'

import { FRAGMENT_CONVERSATION_AVATARS_CONVERSATION } from './ConversationAvatars.hasura'
import { FRAGMENT_CONVERSATION_MEMBERS_MODAL_CONVERSATION } from './ConversationMembersModal.hasura'
import { FRAGMENT_CONVERSATION_MENU_CONVERSATION } from './ConversationMenu.hasura'
import { FRAGMENT_CONVERSATION_TITLE_CONVERSATION } from './ConversationTitle.hasura'

export const FRAGMENT_CONVERSATION_HEADER_CONVERSATION = gql`
  fragment ConversationHeaderConversation on conversation {
    id
    conversation_users {
      id
    }
    current_conversation_user: conversation_users(where: { user_id: { _eq: $currentUserId } }) {
      archived_at
    }
    external_uuid

    ...ConversationAvatarsConversation
    ...ConversationTitleConversation
    ...ConversationMembersModalConversation
    ...ConversationMenuConversation
  }
  ${FRAGMENT_CONVERSATION_AVATARS_CONVERSATION}
  ${FRAGMENT_CONVERSATION_TITLE_CONVERSATION}
  ${FRAGMENT_CONVERSATION_MEMBERS_MODAL_CONVERSATION}
  ${FRAGMENT_CONVERSATION_MENU_CONVERSATION}
`
